import React, { useState, useEffect } from 'react';
import { Toaster } from './components/ui/sonner';
import Sidebar from './components/Sidebar';
import CAUForm from './components/CAUForm';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';
import ManualPage from './components/ManualPage';
import AdminPDFs from './components/AdminPDFs';
import RecibiForm from './components/RecibiForm';
import ActivateAccount from './components/ActivateAccount';
import './App.css';

const SESSION_KEY = 'valoriza_it_session';

export default function App() {
  const [activePage, setActivePage] = useState('form');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return sessionStorage.getItem(SESSION_KEY) === 'true';
  });

  // Check if this is the activation route (public route) - AFTER hooks
  const isActivationRoute = window.location.pathname === '/activate' || window.location.search.includes('token=');

  const handleLogin = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(SESSION_KEY);
    setIsLoggedIn(false);
  };

  // If activation route, show activation page (no auth needed)
  if (isActivationRoute) {
    return (
      <>
        <ActivateAccount />
        <Toaster position="top-right" richColors />
      </>
    );
  }

  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} />;
  }

  return (
    <div className="app-wrapper">
      <Sidebar
        activePage={activePage}
        setActivePage={setActivePage}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        onLogout={handleLogout}
      />
      <div className="main-content">
        {(() => {
          switch (activePage) {
            case 'form':
              return <CAUForm />;
            case 'dashboard':
              return <Dashboard />;
            case 'manual':
              return <ManualPage onBack={() => setActivePage('form')} />;
            case 'admin-pdfs':
              return <AdminPDFs />;
            case 'recibi':
              return <RecibiForm />;
            default:
              return <Dashboard />;
          }
        })()}
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
